import { Controller, useFormContext } from 'react-hook-form';
import { Radio, RadioGroup } from '@ds';
import { YES_NO_OPTIONS } from '@lp/features/admin/forms/config';

interface ControlledYesNoRadioProps {
  name: string;
  isReadOnly?: boolean;
  onValueChange?: (value: string) => void;
}

export const ControlledYesNoRadio = ({ name, isReadOnly, onValueChange }: ControlledYesNoRadioProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value: fieldValue, onChange, ...field }, fieldState: { invalid, error } }) => (
        <RadioGroup
          className="gap-8"
          orientation="horizontal"
          value={fieldValue?.toString()}
          isInvalid={invalid}
          isDisabled={isReadOnly}
          errorMessage={error?.message}
          onValueChange={(val) => {
            if (onValueChange) {
              onValueChange(val);
            } else {
              onChange(val === 'true');
            }
          }}
          {...field}
        >
          {YES_NO_OPTIONS.map((option) => (
            <Radio
              className="w-[100px] max-w-none"
              key={option.value.toString()}
              value={option.value.toString()}
              size="lg"
            >
              {option.name}
            </Radio>
          ))}
        </RadioGroup>
      )}
    />
  );
};
